import { RootState } from "store/store";

const selectStatusPlan = (state: RootState) => state.statusSlice.statusPlan;

export const selectIsOccupied = (gridElementId: string) => {
  const selector = (state: RootState): boolean => {
    const data = selectStatusPlan(state).find(s => s.id === gridElementId);

    if (!data) return false;
    return data?.isOccupied;
  };
  (selector as any)._fromSelector = "isOccupiedSelector";
  return selector;
};
